import * as React from "react";
import type { SVGProps } from "react";
const SvgXClose = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      fill="#323232"
      d="M7.47 7.47a.75.75 0 0 1 1.004-.052l.056.052 8 8 .052.056a.75.75 0 0 1-1.056 1.056l-.056-.052-8-8-.052-.056A.75.75 0 0 1 7.47 7.47"
    />
    <path
      fill="#323232"
      d="M15.526 7.418a.75.75 0 0 1 1.056 1.056l-.052.056-8 8a.75.75 0 1 1-1.06-1.06l8-8z"
    />
  </svg>
);
export default SvgXClose;
